import type { AllHTMLAttributes } from 'react'

import cn from 'clsx'
import { useHelpCenterContext } from '@/components/HtmlArticle/HelpCenterContext'

import css from './IFrame.module.css'
import { ArcadeEmbed } from '@/components/arcade-embed/arcade-embed'

export type IframeProps = AllHTMLAttributes<HTMLIFrameElement>

const ARCADE_SOFTWARE_DOMAIN_NAME = 'arcade.software'

export function IFrame({ src, children, title, className, ...rest }: IframeProps) {
    const { youTubeComponent: YouTubeComponent } = useHelpCenterContext()
    if (YouTubeComponent && src?.includes('youtube')) {
        const parts = sanitizeYTURL(src).pathname.split('/')
        const videoId = parts[parts.length - 1]
        return (
            <div className={cn(css.iframeContainer, css.bordered)}>
                <YouTubeComponent
                    id={videoId}
                    title={title ?? ''}
                    className="data-screenframe"
                    poster="maxresdefault"
                    webp={true}
                    {...rest}
                />
            </div>
        )
    }

    // Add support for Arcade Software embeds: https://www.arcade.software/.
    if (src?.includes(ARCADE_SOFTWARE_DOMAIN_NAME)) {
        // Extract the id from the src
        const options = src.split('/').pop()
        if (!options) return null
        return <ArcadeEmbed options={options} />
    }

    return (
        <div className={cn(css.iframeContainer, css.bordered)}>
            <iframe src={src} className={className} {...rest}>
                {children}
            </iframe>
        </div>
    )
}

function sanitizeYTURL(url: string) {
    let sanitized = url
    if (sanitized.startsWith('//')) {
        sanitized = `https:${sanitized}`
    }
    return new URL(sanitized)
}
